import { render, staticRenderFns } from "./ModalSendInvoice.vue?vue&type=template&id=1a01c770&"
import script from "./ModalSendInvoice.vue?vue&type=script&lang=js&"
export * from "./ModalSendInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports